import { Sector } from './sector.model';
import { Flow } from './flow.model';
import { isNullOrEmpty } from 'app/helper/utils';

export class WorkplanTask {
    id: string | number;
    // The machine the task instance is currently assigned to; required by
    // POST /workplans/set-status-multiple alongside the task id.
    idMachine: string | number;
    // The production plan (workplan) this task belongs to. GET /workplans/full only
    // returns the id, no name — the name is resolved client-side against /workplans.
    idWorkplan: string | number;
    code: string;
    description: string;
    assemblyOrderCode: string;
    dateStart: string;
    dateEnd: string;
    quantity: number;
    duration: number;
    status: string;
    sector: Sector;
    flow: Flow;

    constructor(workplanTask) {
        this.id = workplanTask.id;
        this.idMachine = workplanTask.idMachine;
        this.idWorkplan = workplanTask.idWorkplan;
        this.code = workplanTask.code;
        this.description = workplanTask.description;
        this.assemblyOrderCode = workplanTask.assemblyOrderCode;
        this.dateStart = workplanTask.dateStart;
        this.dateEnd = workplanTask.dateEnd;
        this.quantity = workplanTask.quantity;
        this.duration = workplanTask.duration;
        this.status = workplanTask.status;
        if (!isNullOrEmpty(workplanTask.sector)) { this.sector = new Sector(workplanTask.sector); }
        if (!isNullOrEmpty(workplanTask.flow)) { this.flow = new Flow(workplanTask.flow); }
    }
}
